<template>
  <div class="message">
    <div class="topTitle">
      <div class="select">
        <div class="show" :style="{'left':currentIndex===0? '0': '50%'}"></div>
        <div class="btn"
          v-for="(item, index) in tip"
          :key="index"
          :class="{'active':currentIndex===index}"
          @click="change(item,index)"
        >
          {{item.text}}
        </div>
      </div>
      <div class="clear" v-if="type === 0">
        <van-image @click="clearMessage" class="img" :src="require('@/assets/images/home/icon_clear.png')"></van-image>
      </div>
    </div>
    <div class="section">
      <Empty v-if="detail.totalCount === 0"></Empty>
      <van-list
        v-else
        v-model="detail.loading"
        :finished="detail.finished"
        finished-text="没有更多了"
        @load="getDetail"
      >
        <template>
          <div class="box" v-for="(item,index) in detail.list" :key="index">
            <div class="box_title" v-if="isSome(item , detail.list[index-1])">{{ item.sendDay }}</div>
            <div class="box_content" @click="itemClick(item.type,item.targetId,item.id)">
              <div class="top">
                <div class="box_item">
                  <div class="left">
                    <van-image class="img" v-if="item.type<10" :src="require('@/assets/images/home/icon_info_02.png')"></van-image>
                    <van-image class="img" v-else-if="item.type>=30 && item.type<70" :src="require('@/assets/images/home/icon_info_01.png')"></van-image>
                    <van-image class="img" v-else-if="item.type>=20 && item.type<25" :src="require('@/assets/images/home/icon_info_04.png')"></van-image>
                    <!-- 点赞 -->
                    <van-image class="img" v-else-if="item.type===111" :src="require('@/assets/images/home/icon_info_06.png')"></van-image>
                    <!--评论-->
                    <van-image class="img" v-else-if="item.type===100 || item.type===110" :src="require('@/assets/images/home/icon_info_05.png')"></van-image>
                    <!--关注-->
                    <van-image class="img" v-else-if="item.type===112 || item.type===101" :src="require('@/assets/images/home/icon_info_07.png')"></van-image>
                    <div :class="currentIndex===1 ? 'tip':'' "></div>
                  </div>
                  <div class="right">
                    <div class="text">
                      <div class="st1" v-html="item.title"></div>
                      <div class="st2">{{ item.sendTime }}</div>
                    </div>
                    <div class="info">{{ item.content || '点击查看' }}</div>
                  </div>
                  <p class="p_text"></p>
                </div>
              </div>
              <!-- <div class="bottom">
                <div class="left">
                  <van-image class="img" :src="require('@/assets/images/icon_02.png')"></van-image>
                </div>
                <div class="right">
                  <div class="text">
                    <div class="st1">消息通知</div>
                    <div class="st2">10:29</div>
                  </div>
                  <div class="info">你在项目《非正常人类研究中心》上传了1个资源</div>
                </div>
              </div> -->
            </div>
          </div>
        </template>
      </van-list>
    </div>
  </div>
</template>

<script>
import { Empty } from '@/components';
export default {
  props: {

  },
  components: {
    Empty
  },
  data () {
    return {
      currentIndex: 0,
      tip: [{ text: '已读', id: 1 }, { text: '未读', id: 0 }],
      type: 1, // 0 未读  1已读
      detail: {
        finished: false,
        loading: false,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 10
      }
    };
  },
  computed: {
  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

    /* 初始化数据 */
    init () {
      this.detail = {
        finished: false,
        loading: true,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 10
      };

      this.getDetail();
    },

    /* 获取详情数据 */
    getDetail () {
      let { $http, detail, type } = this;
      const { pageSize, pageNo } = detail;
      $http.get('message/list', {
        params: {
          pageSize,
          pageNo,
          type
        },
        showLoading: true,
        loadingText: '加载中...'
      }).then((res) => {
        const { isHasNext, nextPage, result, totalCount } = res.data.page || {};
        detail.finished = !isHasNext;
        detail.list.push(...result);
        for (let item of detail.list) {
          console.log(item);
          [item].forEach((item) => {
            item.title = item.title.replace(new RegExp(`(${item.keywords.replaceAll(',', ')|(')})`, 'g'), (val) => `<b> ${val} </b>`);
          });
        }
        detail.pageNo = nextPage;
        detail.loading = false;
        detail.totalCount = totalCount;
        this.detail = detail;
      });
    },

    /* 点击跳转到对应的详情页 */
    itemClick (typeId, id, itemId) {

      /*
        typeId
        * 1~19 跳转工作室
          20~59跳转项目页面
          60~62跳转项目页面
          100~101跳转提问页面
          110~112跳转回答页面
        *
        *
        * */
      const { type, $http, $router } = this;
      if (type === 0) {
        $http.put('message/read', {
          id: itemId
        }).then((res) => {

        });
      }
      let url = '';
      console.log(typeId);
      if (typeId < 20) {
        url = 'StudioDetail';
      } else if (typeId >= 20 && typeId < 64) {
        url = 'ProjectDetail';
      } else if (typeId >= 100 && typeId < 102) {
        url = 'AskQuestion';
      } else if (typeId >= 110 && typeId < 113) {
        url = 'WriteAnswer';
      }
      $router.push({
        name: url,
        params: {
          id
        }
      });

    },

    /* 清除消息记录 */
    clearMessage () {
      const { $http } = this;
      $http.put('message/allRead').then(({ result }) => {
        // if(res.data.)
        // console.log(result);
        if (result === 1) {
          this.detail.list = [];
        }
      });
    },

    /* 切换消息通知 */
    change (item, index) {
      this.currentIndex = index;
      this.type = item.id;
      this.init();
    },

    /* 判断日期是否相同 */
    isSome (item, item1) {
      return item1 ? item.sendDay !== item1.sendDay : true;
    }
  }
};
</script>

<style scoped lang="less">
  .message{
    padding: 80px 28px 20px;
    background-color: #fff;
    .topTitle{
      display: flex;
      top: 90px;
      padding: 20px 0;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 42px;
      position: fixed;
      left: 28px;
      right: 28px;
      background-color: #fff;
      z-index: 9;
      .select{
        width: 240px;
        background: #F7F8FA;
        border-radius: 32px;
        display: flex;
        align-items: center;
        position: relative;
        .btn{
          display: inline-block;
          width: 116px;
          font-size: 26px;
          padding: 10px 32px;
          font-weight: bold;
          position: relative;
          line-height: 44px;
          color: #999AAA;
          &.active{
            color: #FFFFFF;
            transition: all .5s;
          }
        }
        .show{
          position: absolute;
          width: 116px;
          height: 100%;
          border-radius: 32px;
          background: #5FA9FF;
          // transform: translate(-50%);
          transition: all .5s;
        }
      }
      .clear{
        .img{
          width: 39px;
          height: 41px;
        }
      }
    }
    .section{
      margin-top: 38px;
      .box{
        margin-bottom: 38px;
        &:last-child{
          margin-bottom: 0;
        }
        .box_title{
          font-size: 30px;
          font-weight: bold;
          color: #333444;
          margin-bottom: 26px;
        }
        .box_content{
          .top,.bottom{
            font-size: 24px;
            font-weight: bold;
            width: 100%;
            color: #333444;
            .left{
              float: left;
              margin-right: 12px;
              position: relative;
              .img{
                width: 88px;
                height: 88px;
                display: inline-block;
              }
              .tip{
                position: absolute;
                width: 12px;
                height: 12px;
                background: #FF485D;
                border: 2px solid #FFFFFF;
                border-radius: 50%;
                top: 4px;
                right: 7px;
              }
            }
            .right{
              padding-top: 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .text{
                display: flex;
                justify-content: space-between;
                margin-bottom: 6px;
                .st1{
                  font-weight: 400;
                }
                .st2{
                  font-size: 24px;
                  color: #999AAA;
                  font-weight: 400;
                  flex-shrink: 0;
                }
              }
              .info{
                font-size: 24px;
                color: #999AAA;
                .text-overflow();
                font-weight: 400;
                padding-right: 76px;
              }
            }
          }
          .top{
            margin-bottom: 40px;
            .box_item{
              .p_text{
                margin-left: 100px;
                padding-bottom: 40px;
                font-weight: 400;
                border-bottom: 1px solid #F0F0F0;
              }
            }
          }
          .bottom{
            .right{
              height: auto;
              border-bottom: 1px solid #F0F0F0;
              padding-bottom: 46px;
              padding-top: 10px;
              .info{
              }
            }
          }
        }
      }
    }
  }
</style>
